import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import { axios, errorResponse } from "../helpers";
import { loginData, logout } from "../stores/auth";

const useGenerateQr = () => {
  const dispatch = useDispatch();
  const navigateGenerate = useNavigate();
  const navigate = useNavigate();
  const dataLogin = useSelector(loginData);
  const [isLoadingGenerate, setIsLoadingGenerate] = useState(false);
  const [errorGenerate, setErrorGenerate] = useState("");
  const [isSuccessGenerate, setIsSuccessGenerate] = useState(false);
  const [isLoadingTemplate, setIsLoadingTemplate] = useState(false);
  const [errorTemplate, setErrorTemplate] = useState("");
  const [isSuccessTemplate, setIsSuccessTemplate] = useState(false);
  const [dataTemplate, setDataTemplate] = useState({});
  const [isLoadingSave, setIsLoadingSave] = useState(false);
  const [errorSave, setErrorSave] = useState("");
  const [isSuccessSave, setIsSuccessSave] = useState(false);
  const [error, setError] = useState("");

  const handleGenerate = async (params) => {
    setIsLoadingGenerate(true);
    try {
      const response = await axios.post(
        "/v1/fabric/qrcode",
        {
          data: params,
        },
        {
          // data: params.form.id,
          headers: {
            Authorization: `Bearer ${dataLogin.data.token}`,
            "Content-Type": params.type ?? "application/json",
          },
          responseType: "blob",
        }
      );
      if (response.status === 200) {
        setIsSuccessGenerate(true);
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "laxmi_qr.pdf";
        a.click();

        window.URL.revokeObjectURL(url);
      } else {
        swal("Error", response.data.message, "error");
        setIsSuccessGenerate(false);
        setErrorGenerate(response.data.message);
      }
    } catch (err) {
      // Deteksi kalau response adalah Blob (karena responseType: "blob")
      if (
        err.response &&
        err.response.data instanceof Blob &&
        err.response.data.type === "application/json"
      ) {
        const text = await err.response.data.text(); // konversi blob ke teks
        const json = JSON.parse(text); // konversi ke object
        const msg = json.message || "Terjadi kesalahan";

        setErrorGenerate(msg);
        setIsSuccessGenerate(false);
        swal("Error", msg, "error");
      } else if (errorResponse(err) === "jwt expired") {
        dispatch(logout());
      } else {
        const msg = errorResponse(err);
        setErrorGenerate(msg);
        setIsSuccessGenerate(false);
        swal("Error", msg, "error");
      }
    } finally {
      setIsLoadingGenerate(false);
    }
  };

  const handleSave = async (params) => {
    setIsLoadingSave(true);
    let newParams = {
      name: "template qr",
      paperWidth: params.paperWidth,
      paperHeight: params.paperHeight,
      boxWidth: params.boxWidth,
      boxHeight: params.boxHeight,
      qrSize: params.qrSize,
      fontSize: params.fontSize,
      marginTop: params.marginTop,
      marginBottom: params.marginBottom,
      marginLeft: params.marginLeft,
      marginRight: params.marginRight,
      gapX: params.gapX,
      gapY: params.gapY,
      showBox: params.showBox,
      logoUrl: params.logoUrl,
      paddingX: params.paddingX,
      paddingY: params.paddingY,
      qrMarginTop: params.qrMarginTop,
      labelGapY: params.labelGapY,
      qrMarginBottom: params.qrMarginBottom,
      qrMarginLeft: params.qrMarginLeft,
      logoSize: params.logoSize,
      gapQrLogo: params.gapQrLogo,
      logoMarginTop: params.logoMarginTop,
      logoMarginBottom: params.logoMarginBottom,
    };
    try {
      const response = await axios.put(
        "/v1/qrTemplate/createTemplate",
        {
          data: newParams,
        },
        {
          // data: params.form.id,
          headers: {
            Authorization: `Bearer ${dataLogin.data.token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        setIsSuccessSave(true);
        swal(
          `${params.titleSuccess ?? "Success!"}`,
          `${params.descSuccess ?? response.data.message}`,
          "success",
          {
            button: "Close",
          }
        ).then(() => {
          setError("");
          if (params.navigation) {
            navigate(params.navigation, { replace: true });
          } else {
            window.location.reload();
          }
        });
      } else {
        swal("Error", response.data.message, "error");
        setIsSuccessSave(false);
        setErrorSave(response.data.message);
      }
    } catch (err) {
      // Deteksi kalau response adalah Blob (karena responseType: "blob")
      if (err.response && err.response.data.type === "application/json") {
        const text = await err.response.data.text(); // konversi blob ke teks
        const json = JSON.parse(text); // konversi ke object
        const msg = json.message || "Terjadi kesalahan";

        setErrorSave(msg);
        setIsSuccessSave(false);
        swal("Error", msg, "error");
      } else if (errorResponse(err) === "jwt expired") {
        dispatch(logout());
      } else {
        const msg = errorResponse(err);
        setErrorSave(msg);
        setIsSuccessSave(false);
        swal("Error", msg, "error");
      }
    } finally {
      setIsLoadingSave(false);
    }
  };

  const getTemplate = async () => {
    try {
      const response = await axios.get("/v1/qrTemplate/getTemplate", {
        // data: params.form.id,
        headers: {
          Authorization: `Bearer ${dataLogin.data.token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        setIsSuccessTemplate(true);
        setDataTemplate(response.data.data);
      } else {
        swal("Error", response.data.message, "error");
        setIsSuccessTemplate(false);
        setErrorTemplate(response.data.message);
      }
    } catch (err) {
      // Deteksi kalau response adalah Blob (karena responseType: "blob")
      if (
        err.response &&
        err.response.data instanceof Blob &&
        err.response.data.type === "application/json"
      ) {
        const text = await err.response.data.text(); // konversi blob ke teks
        const json = JSON.parse(text); // konversi ke object
        const msg = json.message || "Terjadi kesalahan";

        setErrorTemplate(msg);
        setIsSuccessTemplate(false);
        swal("Error", msg, "error");
      } else if (errorResponse(err) === "jwt expired") {
        dispatch(logout());
      } else {
        const msg = errorResponse(err);
        setErrorTemplate(msg);
        setIsSuccessTemplate(false);
        swal("Error", msg, "error");
      }
    } finally {
      setIsLoadingTemplate(false);
    }
  };
  return {
    isLoadingGenerate,
    errorGenerate,
    isSuccessGenerate,
    isLoadingTemplate,
    errorTemplate,
    isSuccessTemplate,
    dataTemplate,
    navigateGenerate,
    handleGenerate,
    getTemplate,
    handleSave,
  };
};

export default useGenerateQr;
